// Importation statique de SimpleBar
import SimpleBar from 'simplebar';

console.log('simplebar-init.js');

export default {
    init() {
        // Vérifie si l'appareil est principalement tactile en regardant le nombre de points de contact
        const isTouchDevice = navigator.maxTouchPoints > 0;

        // Si c'est un appareil tactile, on n'initialise pas SimpleBar
        if (isTouchDevice) {
            console.log('Appareil tactile détecté, SimpleBar non initialisé.');
            return;
        }

        // Optionnel : on peut garder la vérification de hover comme sécurité supplémentaire pour les appareils non-tactiles
        // const hasHover = window.matchMedia('(hover: hover)').matches;
        // if (!hasHover) return;

        console.log('Appareil non tactile détecté, initialisation de SimpleBar...');
        // Sélectionne tous les éléments avec l'attribut data-js="simplebar"
        const simplebarElements = document.querySelectorAll('[data-js="simplebar"]');

        if (!simplebarElements.length) return;

        // Initialise Simplebar sur chaque élément
        simplebarElements.forEach(element => {
            new SimpleBar(element);
        });
    }
}